import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button
} from '@mui/material';
import closeIcon from '../../assets/icons/closeIcon.svg';

export const TableInfoModal = ({ onClose }: { onClose: () => void }) => {
  return (
    <Box
      sx={{
        maxWidth: 500,
        maxHeight: '80vh',
        padding: '1rem',
        borderRadius: '0.9375rem',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        gap: '0.625rem',
        display: 'flex',
        flexDirection: 'column'
      }}
      component={Paper}
    >
      <Button sx={{ justifyContent: 'end' }} onClick={onClose}>
        <img src={closeIcon} alt="Close" />
      </Button>
      <TableContainer>
        <Table>
          <TableHead
            sx={{
              backgroundColor: '#F2F2F2'
            }}
          >
            <TableRow sx={{ height: '45px' }}>
              <TableCell
                sx={{
                  fontSize: '1rem',
                  fontWeight: 450,
                  lineHeight: '1.4375rem',
                  color: '#002A3A',
                  height: '1.5625rem',
                  borderLeft: '0.0625rem solid #D9D9D6',
                  borderRight: '0.0625rem solid #D9D9D6',
                  borderTop: '0.0625rem solid #D9D9D6',
                  textAlign: 'center'
                }}
              >
                Adult Requirements
              </TableCell>
              <TableCell
                sx={{
                  fontSize: '1rem',
                  fontWeight: 450,
                  lineHeight: '1.4375rem',
                  color: '#002A3A',
                  height: '1.5625rem',
                  borderLeft: '0.0625rem solid #D9D9D6',
                  borderRight: '0.0625rem solid #D9D9D6',
                  borderTop: '0.0625rem solid #D9D9D6',
                  textAlign: 'center'
                }}
              >
                Paediatric Requirements
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              overflow: 'auto',
              // Firefox scrollbar styling
              scrollbarWidth: 'thin',
              // Webkit scrollbar styling (Chrome, Safari, Edge)
              '&::-webkit-scrollbar': {
                width: '0.5rem'
              },
              '&::-webkit-scrollbar-track': {
                background: '#f1f1f1',
                borderRadius: '0.25rem'
              },
              '&::-webkit-scrollbar-thumb': {
                background: '#888',
                borderRadius: '0.25rem'
              },
              '&::-webkit-scrollbar-thumb:hover': {
                background: '#555'
              }
            }}
          >
            <TableRow
              sx={{
                fontSize: '1rem',
                fontWeight: 450,
                lineHeight: '1.4375rem',
                color: '#002A3A'
              }}
            >
              <TableCell
                sx={{
                  fontFamily: 'Calibri',
                  borderLeft: '0.0625rem solid #D9D9D6',
                  borderRight: '0.0625rem solid #D9D9D6'
                }}
              >
                <span style={{ fontFamily: 'CalibriBold' }}>Fibre: </span>EFSA
                Panel on Dietetic Products, Nutrition, and Allergies (NDA);
                Scientific Opinion on Dietary Reference Values for carbohydrates
                and dietary fibre. EFSA Journal 2010; 8(3):1462 [77 pp.].
                doi:10.2903/j.efsa.2010.1462.
                <br></br>
                <span style={{ fontFamily: 'CalibriBold' }}>Fibre: </span>
                Scientific Advisory Committee on Nutrition. Carbohydrates and
                Health. London: Public Health England; 2015.
                <br></br>
                <span style={{ fontFamily: 'CalibriBold' }}>Vitamin D: </span>
                Scientific Advisory Committee on Nutrition. Vitamin D and
                Health. London: Public Health England; 2016.
                <br></br>
                <span style={{ fontFamily: 'CalibriBold' }}>Vitamin D: </span>
                EFSA (European Food Safety Authority), 2017. Dietary reference
                values for nutrients: Summary report. EFSA supporting
                publication 2017:e15121, 92pp.
                <br></br>
                <span style={{ fontFamily: 'CalibriBold' }}>*Vitamin K </span>
                requirement is 1mcg/kg/day for adults.
                <br></br>
                <span style={{ fontFamily: 'CalibriBold' }}>¥Vitamin B6 </span>
                requirement is based on protein providing 14.7% of Estimated
                Average Requirements for energy for adults.
                <br></br>
                <span style={{ fontFamily: 'CalibriBold' }}>^Niacin </span>
                requirement is at 6.7mg Niacin Equivalent (NE)/1000kcal. This
                needs to be calculated in line with the patient’s total intakes
                from nutrition support and diet (EFSA, 2017).
                <br></br>
                <span style={{ fontFamily: 'CalibriBold' }}>^^Thiamine </span>
                requirements at 0.42mg/1000kcal. This needs to be calculated in
                line with the patient’s total energy intakes from nutrition
                support and diet (EFSA, 2017).
                <br></br>
                <span style={{ fontFamily: 'CalibriBold' }}>
                  †Pantothenic acid{' '}
                </span>
                requirement is 3mg to reflect the recommendation that intakes
                between 3-7mg/day are adequate for adults.
                <br></br>
                <span style={{ fontFamily: 'CalibriBold' }}>±Biotin </span>
                requirement is at 10mcg to reflect that intakes between
                10-200mcg/day are safe for adults.
                <br></br>
                <span style={{ fontFamily: 'CalibriBold' }}>‡Molybdenum </span>
                requirement is at 50mcg to reflect safe intakes of 50-400mcg/day
                for adults.
                <br></br>
                <span style={{ fontFamily: 'CalibriBold' }}>**Folate </span>
                content in product calculated using US Food and Drug
                Administration (FDA) calculation: Folate (mcg DFE) = Folic acid
                (mcg per serving) × 1.7 (conversion factor for folic acid).
              </TableCell>
              <TableCell
                sx={{
                  fontFamily: 'Calibri',
                  borderLeft: '0.0625rem solid #D9D9D6',
                  borderRight: '0.0625rem solid #D9D9D6',
                  verticalAlign: 'top'
                }}
              >
                <span style={{ fontFamily: 'CalibriBold' }}>
                  Micronutrients and Fibre:{' '}
                </span>
                EFSA (European Food Safety Authority), 2017. Dietary reference
                values for nutrients: Summary report. EFSA supporting
                publication 2017:e15121, 92pp.
                <br></br>
                <span style={{ fontFamily: 'CalibriBold' }}>Sodium: </span>EFSA
                NDA Panel (EFSA Panel on Nutrition, Novel Foods and Food
                Allergens),Turck D, Castenmiller J, de Henauw S, Hirsch-Ernst
                K-I, Kearney J, Knutsen HK, Maciuk A, Mangelsdorf I,McArdle HJ,
                Pelaez C, Pentieva K, Siani A, Thies F, Tsabouri S, Vinceti M,
                Aggett P, Fairweather-Tait S,Martin A, Przyrembel H, Ciccolallo
                L, de Sesmaisons-Lecarre A, Martinez SV, Martino L and Naska A,
                2019.Scientiﬁc Opinion on the dietary reference values for
                sodium. EFSA Journal 2019;17(9):5778, 191 pp.
                <br></br>
                <span style={{ fontFamily: 'CalibriBold' }}>Chloride: </span>
                EFSA NDA Panel (EFSA Panel on Nutrition, Novel Foods and Food
                Allergens), Turck D, Castenmiller J, de Henauw S, Hirsch-Ernst
                K-I, Kearney J, Knutsen HK, Maciuk A, Mangelsdorf I, McArdle HJ,
                Pelaez C, Pentieva K, Siani A, Thies F, Tsabouri S, Vinceti M,
                Aggett P, Fairweather-Tait S, Martin A, Przyrembel H, de
                Sesmaisons-Lecarre A and Naska A, 2019. Scientific Opinion on
                dietary reference values for chloride. EFSA Journal
                2019;17(9):5779, 24 pp.
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
